export const searchSelector = (state) => state.managerHeader.searchText;
export const loginSelector = (state) => state.auth.login;
